import { api } from "../services";
import { PaginatedResult } from "../utils/pagination";

const BASE_URL = "/system-admin/resumedatabase/department";

export const useResumeDatabase = () => {

    const getResumeDatabaseDepartment = async (pageNumber = 1, pageSize = 10, search = "") => {
      const query = new URLSearchParams();
      query.append("pageNumber", pageNumber);
      query.append("pageSize", pageSize);

      if (search) query.append("search", search);

      const response = await api.getPaginated(`${BASE_URL}?${query.toString()}`);
      return new PaginatedResult(response.data, response.pagination);
    };

  const getResumeDatabaseByDepartmentId = async (id="",pageNumber = 1, pageSize = 10, search = "") => {
    const query = new URLSearchParams();
    query.append("pageNumber", pageNumber);
    query.append("pageSize", pageSize);

    if (search) query.append("search", search);

    const response = await api.getPaginated(`${BASE_URL}/${id}?${query.toString()}`);
    return new PaginatedResult(response.data, response.pagination);
  };

  return {
    getResumeDatabaseByDepartmentId,
    getResumeDatabaseDepartment,
  };
};
